import { getAccountSettings, getAdminAccountSettings } from "../types/account_settings_types";

const initState = {
    data: {},
    loading: false,
    error: null,
    cellLoading: null,

    adminData: {},
    adminLoading: false,
};

export default function accountSettingsReducer(state = initState, action = {}) {
    switch (action.type) {
        case getAccountSettings.REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case getAccountSettings.SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null,
            };
        case getAccountSettings.FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case getAdminAccountSettings.REQUEST:
            return {
                ...state,
                adminLoading: true,
                error: null,
            };
        case getAdminAccountSettings.SUCCESS:
            return {
                ...state,
                adminLoading: false,
                adminData: action.payload.data,
                error: null,
            };
        case getAdminAccountSettings.FAILURE:
            return {
                ...state,
                adminLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
